export const companyFormData = {
  name: '',
  server_id: '',
  context: '',
  dcontext: '',
  webfax_content: '',
  asterisk_name: '',
  rec_login_page_url: '',
  rec_username: '',
  rec_password: '',
  worktime_check_url: '',
  worktime_update_status_url: '',
  worktime_start: '09:00',
  worktime_end: '18:00',
  allow_simple_crm: 0,
  is_free: 0,
  use_big: 0,
  is_active: 1,
  send_daily_report: 0,
  daily_report_email_recipient: '',
  daily_report_email_recipient_cc: '',
  extensions: [],
  transfer_numbers: [],
  queues: [],
  dids: [],
  fax_dids: [],
  callback_status: 0,
  inbound_details_is_enabled: 0,
  inbound_details_settings: [],
  keywords: [],
  time_groups: [],
  company_permissions: {
    company_can_manage_messages: false,
    company_can_manage_fax: false,
    company_can_receive_fax: false,
    company_can_download_split_recording: false,
    company_can_manage_time_conditions: false,
    company_can_use_transfer: false,
    company_can_use_queue_history: false,
    company_can_use_recording_manager: false,
    company_can_use_worktime_switch: false,
    company_can_use_outbound_call_popup: false,
    company_can_click_to_call_outbound_call_popup: false,
    company_can_use_dashboard: true,
    company_can_use_configuration: true,
    company_can_use_manage_users: true,
    company_can_use_consultations: true,
    company_can_use_members: true,
    company_can_use_my_account: true,
    company_can_use_task: true,
    company_can_use_projects: true,
    company_can_use_queues: true,
    company_can_use_call_statistics: true,
    company_can_use_message_management: true,
    company_show_dashboard_statistics: false,
    company_can_use_callback_share_function: false,
    company_can_use_slogan: false,
    company_can_use_callback_amount: false,
    company_can_schedule_push_notification: false,
    company_can_upload_sound_file: false,
    company_can_auto_call_system: false,
    company_can_auto_call_system_public: false,
    company_can_provide_agent_api: false,
    company_can_use_branch_extension: false,
    company_can_use_extension_status_data_analysis: false,
    company_call_time_notation_method: false,
    ob_queue_status: false,
    company_can_use_callnote: false,
    company_can_use_queue_all: false,
    company_can_use_blacklist: false,
    send_email_function: false,
    company_hide_reset_button_for_queues: false,
    company_can_modify_queue: false
  },
  queue_statuses: []
}
